export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VerificaNoteCard.vue?vue&type=template&id=0855a30e&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/VerificaNoteCard.vue?vue&type=template&id=0855a30e&
// module id = 817
// module chunks = 0